/* Redux saga class
 * logins the user into the app
 * requires username and password.
 * un - username
 * pwd - password
 */
import { put, call } from 'redux-saga/effects';
import * as signupActions from '../actions/signupActions';
import * as accountActions from '../actions/accountActions';
import * as caseActions from '../actions/caseActions';
//import NavigationService from '../navigation/NavigationService';
import * as Constants from '../config/constants';
import awsUserSignup from '../api/methods/awsUserSignup';
import awsUserLogin from '../api/methods/awsUserLogin';
import Api from '../api/index';
//import { showMessage } from 'react-native-flash-message';
import * as loginActions from '../actions/loginActions';

// Our worker Saga that logins the user
export function* signupSaga(action) {
  try {
    console.log('signupSaga:signupSaga - Start to sign up on aws ');
    var user = yield call(awsUserSignup.signUp, action);
    if (user.username !== undefined) {
      console.log('signupSaga:signupSaga - Sign up successful', action.email);
      //var msg = 'Sign up successful. Verification code is sent to your email.';
      //showMessage({ message: msg, type: 'success', duration: 6000 });
      var response = yield put(signupActions.onSignupResponse());
      console.log('Call signupActions.onSignupResponse ', response);
      //NavigationService.navigate('ConfirmSignUp', {
      //  email: action.accountRequest.email,
      //  password: action.accountRequest.password,
      //  firstName: action.accountRequest.firstName,
      //  lastName: action.accountRequest.lastName,
      //  phone: action.accountRequest.phone
      //});
      // console.log(
      // 'signupSaga:signupSaga - navigate to Confirm Sign Up with email:',
      // action.accountRequest.email
      // );
    } else if (user.message !== undefined) {
      switch (user.code) {
        case 'UsernameExistsException':
          message = user.message + '. Please try to login by clicking link below: Login here.';
          break;
        default:
          break;
      }
      yield put(signupActions.signupFailed(message));
      console.log('signupSaga:signupSaga - Failed to sign up. Error from AWS:', user.message);
      //showMessage({ message: user.message, type: 'danger', duration: 6000 });
    } else {
      var message = Constants.CREATE_ACCOUNT_ERROR;
      switch (user.code) {
        case 'InvalidPasswordException':
          message =
            'Password must contain 12 characters or more, one uppercase, one lowercase, one number and one special case character.';
          break;
        default:
          break;
      }
      //showMessage({ message: message, type: 'danger', duration: 6000 });
      yield put(signupActions.signupFailed(message));
      console.log('signupSaga:signupSaga - Failed to sign up. Error from AWS:', user.message);
    }
  } catch (error) {
    console.log('signupSaga:signupSaga - Error signing up: ', error);
    //showMessage({
    //  message: 'Error signing up: error',
    //  type: 'danger',
    //  duration: 6000
    //});
  }
}

export function* confirmSignUpSaga(action) {
  try {
    var data = yield call(awsUserSignup.confirmSignUp, action);
    if (data === 'SUCCESS') {
      console.log('signupSaga:confirmSignUpSaga - Account creation in aws is successful.');
      var response;
      // create account entry in backend
      try {
        //var msg = 'Sign up is confirmed successful.';
        //showMessage({message: msg, type: 'success', duration: 6000});
        //the user finished signup, login and authenticated
        var login = { email: action.email, password: action.password };
        var user = yield call(awsUserLogin.user, login);
        console.log(user);
        // login success
        if (user.username !== undefined) {
          // hack - update cache with backend phone instead of aws's
          response = yield put(loginActions.onLoginResponse(user.attributes));
          console.log('Call loginSaga.onLoginResponse ', response);
          // token is not refresh if using awsUserInfo
          //var token = yield call(awsUserInfo.currentJwtToken);
          var token = user.signInUserSession.idToken.jwtToken;
          console.log(`token from signupSaga.js: ${user.signInUserSession.idToken.jwtToken}`);
          var accountRequest = {
            userId: 0,
            firstName: response.userDetail.given_name,
            lastName: response.userDetail.family_name,
            email: response.userDetail.email,
            phone: action.phone, // SOP2 phone store different format as AWS
            status: ''
          };
          console.log('signupSaga:confirmSignUpSaga - Start to create a new user ');
          // response = yield put(accountActions.requestCreateAccount(action));
          const apiResponse = yield Api('v1/user/', accountRequest, 'POST', token);
          var status = 0;
          if (apiResponse.statusCode === undefined) {
            var errMessage = `Failed to create a new user. ${apiResponse.message}`;
            console.log('accountSaga:createAccountSaga - ', errMessage);
            yield put(accountActions.createAccountFailed(apiResponse.message));

            // remove aws account
            data = yield call(awsUserSignup.removeAccount);
            console.log(data);
            response = yield put(signupActions.confirmSignUpFailed(errMessage));
          } else {
            status = apiResponse.statusCode;
          }
          if (status >= 200 && status < 300) {
            console.log(
              'signupSaga:confirmSignUpSaga - A new user is created successfully. User id = ',
              apiResponse.result
            );
            response = yield put(accountActions.onCreateAccountResponse(apiResponse));
            console.log('Call accountActions.onCreateAccountResponse ', response);
            // update phone to UI cache
            yield put(accountActions.requestGetPhone());
            // reset
            response = yield put(caseActions.clearCase());
            var message = Constants.CREATE_ACCOUNT_SUCCESS;
            response = yield put(signupActions.onConfirmSignUpResponse());
            console.log('call signupActions.onConfirmSignUpResponse', response);
          } else {
            // remove aws account
            data = yield call(awsUserSignup.removeAccount);
            console.log(data);

            if (apiResponse.isError === true) {
              console.log(
                'signupSaga:confirmSignUpSaga - Create a new user failed:',
                apiResponse.message
              );
              var errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
              response = yield put(accountActions.createAccountFailed(errorMessage));
              console.log('signupSaga.confirmSignUpSaga ', response);
              yield put(signupActions.confirmSignUpFailed(response));
            }
          }
        }
        // login failed e.g. Email/Password invalid
        else {
          message = Constants.LOGIN_ERROR;
          switch (user.code) {
            case 'InvalidParameterException':
            case 'NotAuthorizedException':
            case 'UserNotFoundException':
              message = "The user name or password you entered isn't correct. Please try again.";
              break;
            case 'UserNotConfirmedException':
              message = 'Your account is not confirmed. Please confirm your account.';
              break;
            default:
              break;
          }
          //showMessage({
          //message: message,
          //  type: 'danger',
          //  duration: 6000
          //});
          // yield put(loginActions.loginFailed(message));
          yield put(signupActions.confirmSignUpFailed(message));
          console.log('loginSaga:login - Failed to login. Error from AWS:', user.message);
        }
      } catch (error) {
        if (error) {
          //msg = 'Create a new user failed.' + error;
          console.log('signupSaga:confirmSignUpSaga - Create a new user failed.', error);
          //showMessage({ message: msg, type: 'danger', duration: 6000 });
          yield put(accountActions.createAccountFailed(error));
        }
        // remove aws account
        data = yield call(awsUserSignup.removeAccount);
        console.log(data);
        yield put(signupActions.confirmSignUpFailed(error));
      }
    } else if (data.message !== undefined) {
      message = Constants.CREATE_ACCOUNT_ERROR;
      switch (data.code) {
        case 'CodeMismatchException':
          message = "The verification code you entered isn't correct. Please try again. ";
          break;
        case 'ExpiredCodeException':
          message = 'The verification code you entered is expired. Please try again. ';
          break;
        case 'NotAuthorizedException':
          message = 'The user is already signed up and confirmed. Please try to login.';
          break;
        // invalid email
        case 'UserNotFoundException':
          message = "The user name or password you entered isn't correct. Please try again.";
          break;
        default:
          message = data.message;
          break;
      }
      console.log('signupSaga:confirmSignUpSaga - Account creation in aws failed.', message);
      yield put(signupActions.confirmSignUpFailed(message));
    } else {
      console.log('signupSaga:confirmSignUpSaga - Account creation in aws failed.');
      //  yield put(signupActions.disableSignUpLoader({}));
      message = Constants.CREATE_ACCOUNT_ERROR;
      switch (data.code) {
        case 'CodeMismatchException':
          message = "The verification code you entered isn't correct. Please try again. ";
          break;
        case 'ExpiredCodeException':
          message = 'The verification code you entered is expired. Please try again. ';
          break;
        default:
          break;
      }
      yield put(signupActions.confirmSignUpFailed(message));
      console.log(
        'signupSaga:confirmSignUpSaga - Failed to sign up. Error from AWS:',
        data.message
      );
    }
  } catch (error) {
    yield put(signupActions.confirmSignUpFailed(error));
    console.log('signupSaga:confirmSignUpSaga - Account creation in aws failed.', error);
  }
}

export function* resendCodeSignUpSaga(action) {
  try {
    var data = yield call(awsUserSignup.resendSignUp, action);
    var message = Constants.RESEND_CODE_ERROR;
    if (data.message !== undefined) {
      yield put(signupActions.resendCodeSignUpFailed(message + data.message));
      console.log('signupSaga:resendCodeSignUpSaga - Error from AWS:', data.message);
      //showMessage({
      //  message: message + data.message,
      //  type: 'danger',
      //  duration: 6000
      //});
    } else {
      //showMessage({
      //  message: 'A confirmation code is sent to your email.',
      //  type: 'success',
      //  duration: 6000
      //});
      var response = yield put(signupActions.onResendCodeSignUpResponse());
      console.log('call signupActions.resendCodeSignUpSaga', response);
    }
  } catch (error) {
    console.log('signupSaga:resendCodeSignUpSaga - Error resend code ', error);
    yield put(signupActions.resendCodeSignUpFailed(Constants.RESEND_CODE_ERROR));
    //  yield put(signupActions.disableSignUpLoader({}));
    //var errMessage = 'Resend code failed.';
    console.log('signupSaga:resendCodeSignUpSaga - Account creation in aws failed.', error);

    //showMessage({
    //  message: errMessage,
    //  type: 'danger',
    //  duration: 6000
    //});
  }
}
